import { string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Text } from '@olist/united';

import { cnpjFormatter } from '../../../utils/formatters';

const BankAccountHeader = ({ cnpj }) => {
  const { t } = useTranslation();

  const isACnpj = cnpj && cnpj.replace(/\D/g, '').length === 14;
  if (!isACnpj) return null;

  const cnpjFormatted = cnpjFormatter(cnpj);

  return (
    <header data-role="bank-account-header">
      <Text color="foundation.shadeDark">
        {t`Register the PJ bank account linked to the CNPJ:`}
        <br />
        <Text
          color="foundation.shadeDarker"
          mt={2}
          mb={2}
          style={{ display: `inline-block`, marginRight: `5px`, fontWeight: 600 }}
        >
          {cnpjFormatted}
        </Text>
      </Text>
      <Text color="foundation.shadeDark" mb={5}>
        {t`If the data is incorrect the transfers will not be realized.`}
      </Text>
    </header>
  );
};

BankAccountHeader.defaultProps = {
  cnpj: ``,
};

BankAccountHeader.propTypes = {
  cnpj: string,
};

export default BankAccountHeader;
